import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "name", "className", "inline", "value", "style", "onChange"];
import React, { Children, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Row, Col } from "../Layout";
var RadioGroup = /*#__PURE__*/React.forwardRef(function RadioGroup(_ref, ref) {
  var children = _ref.children,
      name = _ref.name,
      className = _ref.className,
      inline = _ref.inline,
      value = _ref.value,
      style = _ref.style,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, _excluded);

  var Element = inline ? Row : Col;
  return /*#__PURE__*/React.createElement(Element, _extends({}, props, {
    ref: ref
  }), Children.map(children, function (child) {
    return /*#__PURE__*/isValidElement(child) && /*#__PURE__*/cloneElement(child, {
      name: name,
      onChange: onChange,
      checked: child.props.value === value
    });
  }));
});
RadioGroup.defaultProps = {
  name: '',
  className: '',
  value: '',
  onChange: noop,
  style: {},
  inline: false
};
RadioGroup.propTypes = {
  /** The radioGroup children to render */
  children: PropTypes.node.isRequired,

  /** Callback for on radio change */
  onChange: PropTypes.func,

  /** Additional class to radioGroup root */
  className: PropTypes.string,

  /** Additional style to radioGroup root */
  style: PropTypes.shape(),

  /** value will be return when click on this item */
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Identifier will be return when click on this element */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** The value of the selected radio  */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape()]),

  /** Render group inline or not */
  inline: PropTypes.bool
};
RadioGroup.displayName = 'RadioGroup';
export default RadioGroup;